import { getCookieAuthInfo, removeCookieAuthInfo, setCookieAuthInfo } from '@/utils'
import { useAtom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'

interface SyncStorage<Value> {
  getItem: (key: string, initialValue: Value) => Value
  setItem: (key: string, newValue: Value) => void
  removeItem: (key: string) => void
}

const storageOption: SyncStorage<boolean | null> = {
  getItem(key) {
    const value = getCookieAuthInfo(key)[key]
    return JSON.parse(value ?? 'null')
  },
  setItem(key, value) {
    setCookieAuthInfo(key, JSON.stringify(value))
  },
  removeItem(key) {
    removeCookieAuthInfo(key)
  },
}

export const isDarkModeAtom = atomWithStorage<boolean | null>('darkMode', null, storageOption)
isDarkModeAtom.debugLabel = 'isDarkModeAtom'

export const useDarkModeAtom = () => {
  const [isDarkMode, setIsDarkMode] = useAtom(isDarkModeAtom)

  return {
    isDarkMode,
    setIsDarkMode,
  }
}
